import React from "react";
import Card from "../../../../componets/Card";
import { TemplateInterface } from "../../../../store/roblox/templatesSlice";

const _Details = ({ template }: { template: TemplateInterface | undefined }) => {
  return (
    <>
      <Card className='v-mb-20'>
      </Card>
    </>
  );
}

export default _Details;
